export interface ItemSelectFormValues {
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  stores: Marketing.TaskStore[];
  selectedItems: Aide.SelectedItem[];
  skuEnable?: boolean | 'view';
  selectFlag: number;
}

export type FV = ItemSelectFormValues;

export const isItemSelected = (selectedItem: Aide.SelectedItem, item: Aide.Item) => {
  return (
    item.externalItemId === selectedItem.spuId &&
    item.externalShopId === selectedItem.externalStoreId
  );
};

export const isItemChecked = (selectedItems: Aide.SelectedItem[], item: Aide.Item) => {
  const target = selectedItems.find((selectedItem) => isItemSelected(selectedItem, item));

  if (!target) {
    return false;
  }

  const { skuIds } = target;

  if (skuIds.length === 0) {
    return true;
  }

  return item.skuInfo.every(({ skuId }) => skuIds.includes(skuId));
};

export const getItemsCheckedNext = (
  selectedItems: Aide.SelectedItem[],
  items: Aide.Item[],
  checked: boolean,
) => {
  const next = selectedItems.filter(
    (selectedItem) => !items.some((item) => isItemSelected(selectedItem, item)),
  );

  if (checked) {
    next.push(
      ...items.map(({ externalShopId, externalItemId }) => {
        return {
          externalStoreId: externalShopId,
          spuId: externalItemId,
          skuIds: [],
        };
      }),
    );
  }

  return next;
};
